import { hasWebGL } from "./api";

const params = new URLSearchParams(window.location.search);
const forced = params.get("immersion");

export const perf = { fps: 60, forced, debug: params.get("debug") === "1" };
export const reducedMotion = () => !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
// a slow device for the light-weight gallery touches (arrival, hall); journeys never use this to demote
export const slowDevice = () => perf.fps < 28;
// last few painting taps and what became of them (read by checks and ?debug=1)
export const noteTap = (r) => (window.__afaeTaps = [...(window.__afaeTaps || []).slice(-19), { r, t: Math.round(performance.now()) }]);
// tap → response timings for the ?debug=1 timer (journey start, Next → glide)
export const times = (window.__afaeTimes = {});
export const mark = (k, reset) => {
  if (reset) for (const r of reset) delete times[r];
  times[k] = performance.now();
  window.dispatchEvent(new Event("afae-times"));
};

let gl2 = null;
export function hasWebGL2() {
  if (gl2 !== null) return gl2;
  try {
    const gl = document.createElement("canvas").getContext("webgl2");
    gl2 = !!gl;
    gl?.getExtension("WEBGL_lose_context")?.loseContext();
  } catch {
    gl2 = false;
  }
  return gl2;
}

// Crash guard: counts 3D gallery starts that never became healthy (a tab crash reloads the page); a crash only makes the
// next start lighter, it never sends the visitor to a flat view
const GL_TRIES = "afae-gl-tries";
const tries = () => Number(sessionStorage.getItem(GL_TRIES) || 0);
export const glCrashed = () => tries() >= 1;
let counted = false;
export const glStart = () => {
  if (counted) return;
  counted = true;
  sessionStorage.setItem(GL_TRIES, String(tries() + 1));
};
export const glHealthy = () => sessionStorage.setItem(GL_TRIES, "0");
export const glGiveUp = () => sessionStorage.setItem(GL_TRIES, "2");

// Projection rooms and journeys run in full by default (resolution adapts); only a missing WebGL means the simple path.
export function immersionChoice() {
  if (forced === "simple" || forced === "full") return { mode: forced, reason: `forced by ?immersion=${forced}` };
  if (!hasWebGL()) return { mode: "simple", reason: "no WebGL" };
  if (!hasWebGL2()) return { mode: "simple", reason: "no WebGL2" };
  return { mode: "full", reason: "WebGL2 available; resolution adapts to the device" };
}
export function immersionMode() {
  return immersionChoice().mode;
}
// What a journey chose and why, for ?debug=1 and the console.
export function logMode(where, mode, reason) {
  window.__afaeModeLog = { ...(window.__afaeModeLog || {}), [where]: { mode, reason, at: Math.round(performance.now()) } };
  if (perf.debug) console.info(`[afae] ${where}: ${mode} (${reason})`);
  window.dispatchEvent(new Event("afae-mode"));
}
